import * as normalize from 'utils/normalize';

import getPatientName from 'utils/print/getPatientName';
import getPatientAddress from 'utils/print/getPatientAddress';
import getPatientCityStateZip from 'utils/print/getPatientCityStateZip';
import getPatientFullDob from 'utils/print/getPatientFullDob';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientFullPhone from 'utils/print/getPatientFullPhone';
import getInsuranceID from 'utils/print/getInsuranceID';
import getPatientRecordNumber from 'utils/print/getPatientRecordNumber';
import getPatientWeight from 'utils/print/getPatientWeight';
import getPatientHeightIn from 'utils/print/getPatientHeightIn';
import getPrescriberName from 'utils/print/getPrescriberName';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineDescription from 'utils/print/getOrderLineDescription';
import getOrderLineModel from 'utils/print/getOrderLineModel';
import getOrderLineCharge from 'utils/print/getOrderLineCharge';
import getOrderLineUnits from 'utils/print/getOrderLineUnits';
import getOrderLineSupplyType from 'utils/print/getOrderLineSupplyType';
import getOrderLineTotalCharge from 'utils/print/getOrderLineTotalCharge';
import getOrderTotalCharge from 'utils/print/getOrderTotalCharge';
import getSignature from 'utils/print/getSignature';
import getBusinessName from 'utils/print/getBusinessName';
import getFacilityName from 'utils/print/getFacilityName';
import getBusinessStreet from 'utils/print/getBusinessStreet';
import getFacilityStreet from 'utils/print/getFacilityStreet';
import getBusinessCityStateZip from 'utils/print/getBusinessCityStateZip';
import getFacilityCityStateZip from 'utils/print/getFacilityCityStateZip';
import getBusinessPhone from 'utils/print/getBusinessPhone';
import getFacilityPhone from 'utils/print/getFacilityPhone';
import getBusinessFax from 'utils/print/getBusinessFax';
import getFacilityFax from 'utils/print/getFacilityFax';
import getOrderLineDriverFullName from 'utils/print/getOrderLineDriverFullName';
import getSignatureDate from 'utils/print/getSignatureDate';
import getOrderDeliveryNotes from 'utils/print/getOrderDeliveryNotes';
import getInsuranceInsuredsName from 'utils/print/getInsuranceInsuredsName';
import getInsuranceRelationToInsured from 'utils/print/getInsuranceRelationToInsured';

const DeliveryTicketOrderConfirmationForm = {
  ID: 41,
  Name: 'Order Confirmation Form',
  Type: 'Delivery Ticket',
  Format: 'a4',
  OrderLineMax: 12,
  WithCharge: true,
  Orientation: 'l',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Delivery-Ticket-Order-Confirmation-Form/1.js',
      Logo: {
        x: 7,
        y: 13,
        width: 40,
        height: 18,
      },
      texts: [
        {
          name: 'Business Name',
          getText: props => getFacilityName(props) || getBusinessName(props),
          x: 51,
          y: 13,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Street',
          getText: props => getFacilityStreet(props) || getBusinessStreet(props),
          x: 51,
          y: 16,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business City State Zip',
          getText: props => getFacilityCityStateZip(props) || getBusinessCityStateZip(props),
          x: 51,
          y: 19,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Phone',
          getText: props => getFacilityPhone(props) ? `Tel: ${getFacilityPhone(props)}` : `Tel: ${getBusinessPhone(props)}`,
          x: 51,
          y: 22,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Fax',
          getText: props => getFacilityFax(props) ? `Fax: ${getFacilityFax(props)}` : `Fax: ${getBusinessFax(props)}`,
          x: 51,
          y: 25,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Legal Notice 1',
          getText: (props) => {
            const businessName = getFacilityName(props) || getBusinessName(props);
            return `1. Assignment of Medicare, Medicaid, Medicare Supplemental or other insurance benefits to ${businessName} for medical supplies furnished to me by ${businessName}.
2. Direct billing to Medicare, Medicaid, Medicare Supplemental or other insurer(s).
3. Release of my medical information to Medicare, Medicaid, Medicare Supplemental or other insurer's and their agents and assigns.
4. ${businessName} to obtain medical or other information necessary in order to process my claim(s), including determining eligibility and seeking reimbursement for medical supplies and/or medication(s) provided.`;
          },
          x: 9.7,
          y: 158,
          width: 125,
          fontSize: 6,
          lineHeight: 1.3,
        },
        {
          name: 'Legal Notice 2',
          getText: (props) => {
            const businessName = getFacilityName(props) || getBusinessName(props);
            return `5. ${businessName} to contact me by telephone or mail regarding my medical supplies order. I request that payment to Medicare, Medicaid, Medicare Supplemental or other insurance benefits be made on my behalf to ${businessName} or its affiliates, for any medical supplies and/or medications furnished to me by ${businessName}. I authorize any holder of medical information about me to release to ${businessName} or its affiliates, my physician(s), caregiver, CMS, its agents and to my primary and/or other medical insurer any information needed to determine or secure eligibility information and/or reimbursement for covered services. I agree to pay all amounts that are not covered by my insurer(s) and for which I am responsible.
            ${(props.appInfo && props.appInfo['APP NAME'] === 'alba') ? '6. In the event your complaint remains unresolved with ${businessName}, you may file a complaint with our Accreditor, The Compliance Team, Inc via their website (www.thecomplianceteam.org) or via phone 1-888-291-5353.' : ''}`;
          },
          x: 149,
          y: 158,
          width: 130,
          fontSize: 6,
          lineHeight: 1.3,
        },
                {
          name: 'Legal Notice 3',
          getText: (props) => {
            const businessName = getFacilityName(props) || getBusinessName(props);
            return `I accept delivery of the above equipment. I agree to pay all amounts that are not covered by my insurer(s) including applicable co-payments and/or deductibles for which I am responsible. Attention all patients, since DMEOP products are medical in nature we will not be able to accept any items opened or otherwise used in any form or fashion. Please be aware, we have a No Refund policy on all purchased items. I have read, received and/or been instructed in detail on the items checked above.`;
          },
          x: 9,
          y: 179,
          width: 275,
          fontSize: 6,
          lineHeight: 1.3,
          fontWeight: 'bold',
        },
      ],
      fields: [
        {
          name: 'Type of delivery',
          type: 'radio',
          options: [
            {
              x: 224.5,
              y: 4.5,
              width: 3,
              height: 3,
              value: 'Initial',
            },
            {
              x: 262.5,
              y: 4.5,
              width: 3,
              height: 3,
              value: 'Follow-Up',
            },
          ],
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 129.5,
          y: 8,
          width: 82,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientAddress,
          x: 129.5,
          y: 14,
          width: 82,
        },
        {
          name: 'Patient Phone',
          type: 'text',
          getValue: getPatientFullPhone,
          x: 129.5,
          y: 19,
          width: 33,
          normalize: normalize.phone,
          format: value => (value ? value.replace('+1 ', '') : ''),
        },
        {
          name: 'Patient Alt Phone',
          type: 'text',
          x: 178,
          y: 19,
          width: 33,
          normalize: normalize.phone,
          format: value => (value ? value.replace('+1 ', '') : ''),
        },
        {
          name: 'Patient Record Number',
          type: 'text',
          getValue: getPatientRecordNumber,
          x: 129.5,
          y: 24.5,
          width: 33,
        },
        {
          name: 'Patient Gender',
          type: 'text',
          getValue: getPatientGender,
          x: 178,
          y: 24.5,
          width: 33,
        },
        {
          name: 'Patient Date of Birth',
          type: 'text',
          getValue: getPatientFullDob,
          x: 239,
          y: 8,
          width: 52,
          normalize: normalize.date,
        },
        {
          name: 'Patient City State Zip',
          type: 'text',
          getValue: getPatientCityStateZip,
          x: 239,
          y: 14,
          width: 52,
        },
        {
          name: 'Alternate Contact',
          type: 'text',
          x: 239,
          y: 19,
          width: 52,
        },
        {
          name: 'Patient Weight',
          type: 'text',
          getValue: getPatientWeight,
          x: 239,
          y: 24,
          width: 21,
        },
        {
          name: 'Patient Height',
          type: 'text',
          getValue: getPatientHeightIn,
          x: 274,
          y: 24,
          width: 17,
        },
        {
          name: 'Insurance ID',
          type: 'text',
          getValue: getInsuranceID,
          x: 27,
          y: 34,
          width: 98,
        },
        {
          name: 'Physician Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 154,
          y: 34,
          width: 98,
        },
        {
          name: 'FOLLOW UP VISITS RECOMMENDED',
          type: 'checkbox',
          x: 109,
          y: 41,
          width: 3,
          height: 3,
        },
        {
          name: 'FOLLOW UP BY PHONE & AS NEEDED',
          type: 'checkbox',
          x: 247,
          y: 41,
          width: 3,
          height: 3,
        },
        ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].reduce((accumulator, currentValue) => {
          const y = 54 + (currentValue * 4.9);
          return [
            ...accumulator,
            {
              name: `Qty ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineUnits({ ...props, index: currentValue }),
              x: 6,
              y,
              width: 14,
              normalize: normalize.number,
            },
            {
              name: `UOM ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineSupplyType({ ...props, index: currentValue }),
              x: 23,
              y,
              width: 13,
            },
            {
              name: `Qty Shipped ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineUnits({ ...props, index: currentValue }),
              x: 37,
              y,
              width: 14,
              normalize: normalize.number,
            },
            {
              name: `BOQ ${currentValue}`,
              type: 'text',
              x: 53,
              y,
              width: 13,
            },         
            {
              name: `Description ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDescription({ ...props, index: currentValue }),
              x: 68,
              y,
              width: 78,
            },
            {
              name: `Brand/Model ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineModel({ ...props, index: currentValue }),
              x: 150,
              y,
              width: 38,
            },
            {
              name: `Serial/LOT ${currentValue}`,
              type: 'text',
              x: 190,
              y,
              width: 26,
            },
            {
              name: `HCPCS ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineHCPCSCode({ ...props, index: currentValue }),
              x: 218,
              y,
              width: 34,
              normalize: normalize.hcpcCode,
            },
            {
              name: `Charge ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineCharge({ ...props, index: currentValue }),
              x: 254,
              y,
              width: 16,
              normalize: normalize.price,
              chargeField: true,
            },
            {
              name: `Total Cost ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineTotalCharge({ ...props, index: currentValue }),
              x: 273,
              y,
              width: 16,
              normalize: normalize.price,
              chargeField: true,
            },
          ];
        }, []),
        {
          name: 'Driver Instructions',
          type: 'text',
          getValue: getOrderDeliveryNotes,
          x: 8,
          y: 128,
          width: 280,
          height: 23,
          multiline: true,
        },
        {
          name: 'Patient Signature',
          type: 'signature',
          getValue: getSignature,
          x: 33,
          y: 188,
          width: 60,
          height: 7,
        },
        {
          name: 'Insureds Name',
          type: 'text',
          getValue: getInsuranceInsuredsName,
          x: 33,
          y: 195,
          width: 60,
        },
        {
          name: 'Insureds Relation',
          type: 'text',
          getValue: getInsuranceRelationToInsured,
          x: 101,
          y: 195,
          width: 44,
        },   
        {
          name: 'Drivers Name',
          type: 'text',
          getValue: props => getOrderLineDriverFullName({ ...props, index: 0 }),
          x: 170,
          y: 190,
          width: 58,
        },
        {
          name: 'Date of Delivery',
          type: 'text',
          getValue: getSignatureDate,
          x: 253,
          y: 194,
          width: 29,
          normalize: normalize.date,
        },
      ],
    },
  ],
};

export default DeliveryTicketOrderConfirmationForm;



// WEBPACK FOOTER //
// ./src/config/documents/Delivery-Ticket-Order-Confirmation-Form.js